import atlasApi					from "../utils/atlasapi";
import Cookies					from 'universal-cookie';
import { 
	Warning, 
	CircleNotch, 
	CheckCircle,
}								from "@phosphor-icons/react";


class Tool {

	hiddenItems	= [];
	stylingPanels = [];

	constructor(p) {
		if(p)
			this.tc = p;
	}
	init(){
		if(!this.infolayerId)
			return;
		this.allHidden = this.tc.infoLayers.current ? !this.tc.infoLayers.current.getNode(this.infolayerId).data.defaultChecked : false;
		this.getHiddenItems();
	}
	exit(){
		this.closeStylingPanels();
	}
	setEventHandlers(){
		this.tc.map.on('layer.toggle', this.handleLayerToggle);
	}
	removeEventHandlers(){
		this.tc.map.off('layer.toggle', this.handleLayerToggle);
	}
	
	getPointFeatures(e){
		return this.parent.map.queryRenderedFeatures(e.point, {layers:[this.getToolLayer().layerId]});
	}
	
	getData = () => {
		
		return this.tc.map.getSource(this.getToolLayer().sourceId)?.serialize()?.data;
		
	}
	
	setData = (data) => {
		this.tc.map.getSource(this.getToolLayer().sourceId).setData(data);
	}
	deleteFeature = (id, item_id, cond) => {
		
		
		item_id = !Array.isArray(item_id) ? [item_id] : item_id;
		const data = this.getData();
		if(!data)
			return;
		for (let i = data.features.length - 1; i >= 0; i--) {
			if (item_id.includes(data.features[i].properties[id]) && (!cond || cond(data.features[i])))
				data.features.splice(i, 1);
		}
		
		this.setData(data);
	}
	addFeature = (f) => {
		
		f = !Array.isArray(f) ? [f] : f;
		const data = this.getData();
		if(!data)
			data = {};
		f.forEach((ft)=>{
			data.features.push(ft);
		});
		
		this.setData(data);
	}
	save(promise) {
		const { setters } = this.tc.draw.context;
		setters.setSaveState('saving');
		return promise
			.then((res)  => { 
				
				this.tc.checkOutdated(res);
				setters.setSaveState('finished'); 
				return res; 
			})
			.catch(err => { setters.setSaveState('error');    throw err; });
	}
	
	saveSetting = (tool, value)=>{
		
		const {getters} = this.parent.draw.context;
		
		var user = getters.user;
		
		if(user && user.userDetails && user.settings){
			
			
			
			if(!user.settings.tools){
				user.settings.tools = {};
			}
			if(!user.settings.tools[tool]){
				user.settings.tools[tool] = {};
			}
			user.settings.tools[tool] = {
				...user.settings.tools[tool],
				...value
			}

			atlasApi.updateSettings(user);
		}
		
	}
	getHiddenItems(){
		
		this.hiddenItems = this.tc.scenario[this.itemsName].filter((a)=>{return a.invisible ?? a?.properties?.invisible}).map((a)=>{return a[this.id] ?? a.properties[this.id]});
		
	}
	handleLayerToggle = (e) => {
		if(e.layerId == this.infolayerId)
			this.handleHideAllItems();
	}
	
	handleHideAllItems(){
		if(!this.areAllHidden()){
			this.hiddenItems = this.tc.scenario[this.itemsName].map((t, idx)=>{
				this.toggleItem(t[this.id] ?? t.properties[this.id], true, true);
				return t[this.id] ?? t.properties[this.id];
			});
			this.display();
		}
		else{
			const copy = this.hiddenItems.slice(0);
			copy.forEach((t)=>{this.toggleItem(t, false, true);});
			
		}
	}
	handleToggleItem = (e, item_id, f, dontRefresh)=>{
		e.stopPropagation();
		this.toggleItem(item_id, f, dontRefresh);
	}
	areAllHidden(){
		return this.hiddenItems.length == this.tc.scenario[this.itemsName].length;
	}
		
	toggleItem(item_id, f, dontRefresh, extra){
		
		const force = typeof f == "boolean" ? f : 'undefined';
		const hide = document.querySelector("#bndr_"+item_id)?.classList?.toggle("opacity-25", typeof force == "boolean" ? force : undefined);
		
		
		if(!hide)
			this.tc.infoLayers.current.forceVisibility(this.infolayerId, true);
		
		this.tc.map.setFeatureState({
            source: this.getToolLayer().sourceId,
            id: item_id
        }, {invisible:(force != 'undefined' ? force : hide)});
		
		
		if(!hide){
			const index = this.hiddenItems.indexOf(item_id);
			if (index > -1) {
			  this.hiddenItems.splice(index, 1);
			}
		}
		else
			this.hiddenItems.push(item_id);
		
		
		this.updateScenarioFeatPop(this.id, item_id, {invisible: (force != 'undefined' ? force : hide)});
		this.updateMapFeatPop(this.id, item_id, {invisible: (force != 'undefined' ? force : hide)});
		this.tc.infoLayers.current.updateLayerData(this.infolayerId);
		
		this.tc.infoLayers.current.forceVisibility(this.infolayerId, !this.areAllHidden());	
		
		if(extra)
			extra(item_id, force, hide);

		
	}
	updateMapFeatCoordinates(item_id, coordinates, cond){
		const data = this.getData();
		if(!data)
			return;
		
		for (let i = data.features.length - 1; i >= 0; i--) {
			if ((data.features[i].properties[this.id] == item_id || data.features[i].properties.tempid == item_id) && (!cond || cond(data.features[i])))
				data.features[i].geometry.coordinates = coordinates;
		}
		
		this.setData(data);
	}
	updateMapFeatPop(id, item_id, properties, cond){
		const data = this.getData();
		if(!data)
			return;
		for (let i = data.features.length - 1; i >= 0; i--) {
			if ((data.features[i].properties[id] == item_id || data.features[i].properties.tempid == item_id) && (!cond || cond(data.features[i])))
				data.features[i].properties = {
					...data.features[i].properties,
					...properties
				};
		}
		
		this.setData(data);
	}
	updateScenarioFeatPop(id, item_id, properties){
		
		const s = structuredClone(this.tc.scenario);
		const oldDrawing = s[this.itemsName].find((p)=>{return p[id] == item_id || (p.properties && p?.properties[id] == item_id)});
		
		oldDrawing.properties = {
			...oldDrawing.properties,
			...properties
		}
		this.tc.scenario = s;
		this.tc.setScenario(s);
	}
	
	updateScenarioItemId(id, oldId, newId){
		
		const s = structuredClone(this.tc.scenario);
		const old = s[this.itemsName].find((p)=>{return p[id] == oldId || (p.properties && (p?.properties[id] == oldId || p?.properties.tempid == oldId))});
		
		old[id] = newId;
		old.properties[id] = newId;
		delete old?.properties.tempid;
		
		this.tc.scenario = s;
		this.tc.setScenario(s);
	}
	
	resetLayer = ()=>{
		this.tc.infoLayers.current.resetSystemLayer(this.infolayerId);
		
	}
	
	refreshMap(){
		const data = this.tc.map.getSource(this.getToolLayer().sourceId)._options.data;
		this.tc.map.getSource(this.getToolLayer().sourceId).setData(data);
	}
	
	display = ()=>{
		
		if(this.silent)
			return;
		if(this.tc.serviceBar.current && (this.tc.handler && this.tc.handler.constructor.name == this.constructor.name))
			this.tabIndex =	this.tc.serviceBar.current.inject(this.render(), this.tabIndex);
	}
	setupStreamer = (type) => {
		if(this.silent)
			return;
		// create stream
		this.stream = atlasApi.requestCalcProgress(
			type,
			this.tc.scenario.projectid,
			this.tc.scenario.scenario_id
		);

		this.stream.on("processing", data => {
			try {
				const json = JSON.parse(data);
				this.updateState(json);
			} catch {
				this.handleError();
			}
		});

		this.stream.on("completed", data => {
			try {
				const json = JSON.parse(data);
				this.updateState(json);
			} catch {
				this.handleError();
			}
		});

		this.stream.on("error", err => {
			this.stream.close();
			try {
				this.requestStatus = {
					text:false
				}
			} catch(error) {
				this.handleError(error);
			}
		});

		this.stream.on("message", message => {
			try {
				const json = JSON.parse(message);
				this.updateState(json);
			} catch(error) {
				this.handleError(error);
			}
		});
	}

	updateState = (json) => {
		
		this.statusText = json.message;

		
		switch (this.getStreamerState(json)) {
			case 'processing':
			case 'queued':	
				this.requestStatus = {
					recalculate: false,
					text:this.stateMsgs.pending,
					timeLeft:this.formatRemainingTime(json),
					percent: this.calculatePercent(json),
					icon: <CircleNotch className="spin" weight="bold" size={16} />,
					css: "text-info"
				};
				break;
			case 'completed':
				this.handleDoneCalc();
				this.requestStatus = {
					recalculate: false,
					text:this.stateMsgs.complete,
					timeLeft:'Just now',
					percent:100,
					css: 'text-success',
					icon: <CheckCircle color="green" weight="bold" size={16} />
				}
				this.stream.close()
				this.hideMsg();
				break;
			case 'error':
				//this.hideMsg();
				this.stream.close();
				
				this.requestStatus = {
					recalculate: true,
					text:this.stateMsgs.error,
					timeLeft:'',
					icon: <Warning color="green" weight="bold" size={16} />
				}
				break;
			case 'not_found':
				this.requestStatus = {
					recalculate: true,
					notFound:true,
					text:false,
					timeLeft:false,
					icon: false
				}
				
				this.stream.close();
				break;
			case 'outdated':
				this.requestStatus = {
					recalculate: true,
					notFound:false,
					text:false,
					timeLeft:false,
					icon: false,
					css:'text-warning'
				}
				
				this.stream.close();
				break;
			default:
				this.requestStatus = {
					recalculate: false,
					text:false,
					timeLeft:false,
					icon: false
				}
		}
		this.display();
	}
	
	hideMsg = () => {
		setTimeout(()=>{
			this.requestStatus = {
				recalculate: false,
				text: false,
				timeLeft: false,
				css:'text-idle',
				icon: false
			}
			this.display();
		}, 3000)
	}
	
	handleError = (error) => {
		console.log(error);
		this.requestStatus = {
			recalculate: false,
			text:false,
			timeLeft:false,
			icon: false
		}
		this.display();
	}

	setJobCookie(){
		const expires = new Date();
		expires.setDate(expires.getDate() + 2);
		const jobCookie = new Cookies(null, { path: '/' });
		jobCookie.set(this.type+'-'+this.tc.scenario.projectid+'-'+this.tc.scenario.scenario_id, Date.now(), { expires });
	}
	getJobCookie(){
		
		const jobCookie = new Cookies(null, { path: '/' });
		return jobCookie.get(this.type+'-'+this.tc.scenario.projectid+'-'+this.tc.scenario.scenario_id);
	}
	calculatePercent = ({ estimated_seconds }) => {
		const startTime = this.getJobCookie();
		if (!startTime || estimated_seconds == null) return null;

		const elapsed = (Date.now() - Number(startTime)) / 1000;
		const total = elapsed + estimated_seconds;
		if (total <= 0) return null;

		return Math.min(Math.round((elapsed / total) * 100), 99);
	}

	handleBulkDelete = () => {
		if (!this.selected?.length) return;

		const count = this.selected.length;
		const persistedIds = this.selected
			.map(r => r[this.id] ?? r?.properties?.[this.id])
			.filter(id => id != null && !isNaN(id));

		this.selected.forEach(row => {
			this.removeItem(row[this.id] ?? row?.properties?.[this.id]);
		});
		this.selected = [];

		if (persistedIds.length && this.tc.scenario?.scenario_id && this.bulkDeleteApi)
			this.save(this.bulkDeleteApi(persistedIds));

		this.afterBulkDelete?.(count);
		this.display();
	}

	formatRemainingTime = ({ estimated_seconds, estimated_minutes }) => {
		if (estimated_minutes >= 1) {
			const minutes = Math.ceil(estimated_minutes);
			return `~ ${minutes} minute${minutes > 1 ? 's' : ''}`;
		}

		return 'Finishing...';
	}

	isSelectedOnList = (row) => {
		return this.highlightedOnList.includes(this.idString(row.id));
	}
	idString(id) {
		return isNaN(id) ? id : id.toString();
	}
}
export default Tool;